export default "__VITE_ASSET__CAA3eC2T__"